export function getDurationInMinutes(durationString: string): number {
  return isNaN(Number(durationString)) ? 0 : Number(durationString) / 60;
}
